// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c9ed30dc","703":"e57d10d6"}[chunkId] + ".chunk.js";
};